<template>
  <div class="" :id="this.$route.name" dir="rtl">
    <card back tools toolsColumns>
      <template v-slot:header>
        <h3>مشاهده مشتـــریان</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div id="Filters" class="pr-3 p-2 mt-2 mb-3">
          <div class="row">
            <div id="ShomareOzv" class="col-md-2 col-12 mt-2">
              <small>کد مشتری</small>
              <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.ShomareOzv" dir="ltr" @focusout="CompleteShomareOzv($event)" :placeholder="$session.get('UserInfo').codeShobe.trim() + '-'" v-mask="$Get_FormatShomareOzv()" />
            </div>
            <div id="Tahsilat" class="col-md-2 FilterTag-Static col-12 mt-2 FilterDef">
              <small>شماره حساب | تسهیلات</small>
              <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.Tahsilat" dir="ltr" @focusout="ComplateVcode($event)" v-mask="$session.get('UserInfo').codeShobe.trim() + '-##-######'" :placeholder="$session.get('UserInfo').codeShobe.trim() + '-__-______'" />
            </div>
            <div id="CodeMeli" class="col-md-2 FilterTag-Static col-12 mt-2 FilterDef">
              <small>کد ملی </small>
              <input type="text" v-model="DataAxios.ArryfildValue.CodeMeli" v-mask="'##########'" maxlength="10" @keypress="$ValidNumber($event, 10)" @input="$CheckupLengthCodeMeli($event)" class="form-control required-CodeMeli text-left" />
            </div>
            <div id="OzvName" class="col-md-2 FilterTag-Static col-12 mt-2 FilterDef">
              <small>نام </small>
              <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.OzvName" />
            </div>
            <div id="OzvFamily" class="col-md-2 FilterTag-Static col-12 mt-2 FilterDef">
              <small>نام خانوادگی </small>
              <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.OzvFamily" />
            </div>
            <div id="Shenasname" class="col-md-2 FilterTag-Static col-12 mt-2">
              <small>شماره شناسنامه </small>
              <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.Shenasname" />
            </div>
            <div id="Parvandeh" class="col-md-2 FilterTag-Static col-12 mt-2">
              <small>شماره پرورنده </small>
              <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.Parvandeh" />
            </div>
            <div id="Mobile" class="col-md-2 FilterTag-Static col-12 mt-2">
              <small>تلفن همراه </small>
              <input type="text" class="form-control" v-model="DataAxios.ArryfildValue.Mobile" />
            </div>

            <div id="TblAzaNoeId" class="col-md-2 FilterTag-Static col-12 mt-2">
              <small>حوزه </small>
              <SearchableCombo :edit="false" @ResultCombo="ValueResultHoze" :rownumintable="1" :queryString="{ id: $session.get('UserInfo').tblShobeId }" :action="'TblCombo/GetHoze'" :method="'GET'" :idinput="'TblHozeId'" :keyItem="'TblHozeId'" :disabled="false"> </SearchableCombo>
            </div>
            <div id="TblComboIdVazeit12" class="col-md-2 FilterTag-Static col-12 mt-2">
              <small>وضعیت </small>
              <SearchableCombo :edit="false" @ResultCombo="ValueResultVaziat" :rownumintable="2" :queryString="{ id: 12 }" :action="'TblCombo/GettblCombo'" :method="'GET'" :idinput="'TblVaziatId'" :keyItem="'TblVaziatId'" :disabled="false"> </SearchableCombo>
            </div>
            <div id="TblComboIdMalekiat24" class="col-md-2 FilterTag-Static col-12 mt-2">
              <small>مالکیت </small>
              <SearchableCombo :edit="false" @ResultCombo="ValueResultMalekiat" :rownumintable="3" :queryString="{ id: 24 }" :action="'TblCombo/GettblCombo'" :method="'GET'" :idinput="'Malekiat'" :keyItem="'Malekiat'" :disabled="false"> </SearchableCombo>
            </div>
            <div id="TblTafsiliTypeId" class="col-md-2 FilterTag-Static col-12 mt-2">
              <small>نوع مشتری </small>
              <SearchableCombo :edit="false" @ResultCombo="ValueResultNoeMoshtari" :rownumintable="4" :queryString="{ id: $session.get('UserInfo').tblShobeId }" :action="'TblCombo/GettblTafsiliType'" :method="'GET'" :idinput="'NoeMoshtari'" :keyItem="'NoeMoshtari'" :disabled="false">
              </SearchableCombo>
            </div>
          </div>
          <div class="row mt-2 text-left mr-1">
            <button class="btn btn-success m-1 float-left" dir="ltr" @click.prevent="Search">جستجــو مشتری<i class="fad fa-search ml-2"></i></button><br />
          </div>
        </div>
        <Bnp-Grid :Sortable="true" :action="true" :propsRows="rows" :propsColumn="column" :hasRowNum="true" v-if="$store.state.renderComponentGrid">
          <template slot="action-slot" slot-scope="props">
            <button class="btn btn-outline-info mx-2" dir="ltr" @click="OnDetail(props.props)">مشاهده<i class="fad fa-eye ml-2"></i></button>

            <b-dropdown size="md" variant="link" class="d-inline text-danger text-center" toggle-class="text-decoration-none " no-caret>
              <template #button-content
                ><h4><i class="fad fa-stream text-secondary"></i></h4
              ></template>
              <b-dropdown-item href="#" class="text-center" @click="AzaPasAndJari(props.props)">حسابها</b-dropdown-item>
              <b-dropdown-item href="#" class="text-center" @click="AzaTashilat(props.props)">تسهیلات</b-dropdown-item>
            </b-dropdown>

            <!-- <button class="btn btn-outline-warning mx-2" dir="ltr" @click="AzaPasAndJari(props.props)">حسابها<i class="fad fa-dot-circle ml-2"></i></button>
            <button class="btn btn-success mx-2" dir="ltr" @click="AzaTashilat(props.props)">تسهیلات<i class="fad fa-handshake ml-2"></i></button> -->
          </template>
        </Bnp-Grid>
      </template>
    </card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import BnpGrid from '@/components/BnpGrid/BnpGrid.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
export default {
  components: {
    Card,
    BnpGrid,
    SearchableCombo,
  },
  data() {
    return {
      DataAxios: {
        ArryfildValue: {},
        Action: this.$route.name,
        Method: 'post',
      },
      rows: [],
      column: [],
    }
  },
  methods: {
    CompleteShomareOzv(e) {
      e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
      e.target.value = e.target.value.padStart(6, 0)
      var txt = this.$session.get('UserInfo').codeShobe.trim() + '-' + e.target.value
      console.log(txt)
      this.DataAxios.ArryfildValue.ShomareOzv = txt
    },
    ComplateVcode(e) {
      var vcode = this.$session.get('b_SetVCodeMask').trim().substring(7).replaceAll('0', '#')
      e.target.value = e.target.value.replace(this.$session.get('UserInfo').codeShobe.trim() + '-', '')
      var CodeNoe = e.target.value.substring(0, 3)
      e.target.value = e.target.value.replace(e.target.value.substring(0, 3), '')
      e.target.value = e.target.value.padStart(vcode.length, 0)
      e.target.value = this.$session.get('UserInfo').codeShobe.trim() + '-' + CodeNoe + e.target.value
      this.DataAxios.ArryfildValue.Tahsilat = e.target.value
    },
    Search() {
      try {
        this.DataAxios.ArryfildValue.TblShobeId = this.$session.get('UserInfo').tblShobeId
        this.DataAxios.ArryfildValue.TblGrpId = 1
        this.DataAxios.ArryfildValue.tblShobeIdAccess = 1
        this.DataAxios.ArryfildValue.CanViewInfo = 1
        this.$store.state.renderComponentGrid = false
        this.$PostData(this.DataAxios)
          .then((data) => {
            if (data.length > 0) {
              this.rows = data
              for (let index = 0; index < data.length; index++) {
                this.rows[index]['row'] = index + 1
              }
            } else {
              this.rows = []
              this.$toasted.error('اطلاعاتی با فیلتر انتخابی شما یافت نشد', { duration: 2000 })
            }
          })
          .finally(() => {
            this.$store.state.renderComponentGrid = true
          })
      } catch (error) {
        console.log(error)
      }
    },
    GetGridColumns() {
      let DataAxoisCol = {
        ArryfildValue: {
          SoftwareId: this.$session.get('UserInfo').tblSoftwareId,
          UserId: this.$session.get('UserInfo').tblUserId,
          FormName: 'frmVorodi',
          ShowView: 0,
        },
        Method: 'post',
        Action: 'ReadGridColumns',
      }
      this.$GetColumns(DataAxoisCol, true)
        .then((data) => {
          this.column = data
        })
        .finally(() => {
          this.$store.state.renderComponentGrid = false
          this.$nextTick(() => {
            this.$store.state.renderComponentGrid = true
          })
        })
    },
    ValueResultVaziat(val) {
      this.DataAxios.ArryfildValue.TblComboIdVazeit12 = val.id == null ? 0 : val.id
    },
    ValueResultMalekiat(val) {
      this.DataAxios.ArryfildValue.TblComboIdMalekiat24 = val.id == null ? 0 : val.id
    },
    ValueResultNoeMoshtari(val) {
      this.DataAxios.ArryfildValue.TblTafsiliTypeId = val.id == null ? 0 : val.id
    },
    ValueResultHoze(val) {
      this.DataAxios.ArryfildValue.TblAzaNoeId = val.id == null ? 0 : val.id
    },
    AzaPasAndJari(row) {
      try {
        //   this.$session.set("DetailUser", row);
        this.$router.push({ name: 'AzaPasAndJari', params: { AzaInfo: row } })
      } catch (error) {
        console.log(error)
      }
    },
    AzaTashilat(row) {
      try {
        //   this.$session.set("DetailUser", row);
        this.$router.push({ name: 'AzaTashilats', params: { AzaInfo: row } })
      } catch (error) {
        console.log(error)
      }
    },
    OnDetail(data) {
      var DataAxios_tblaza = {
        ArryfildValue: null,
        Method: 'Get',
        Action: 'AzaInfo',
      }

      DataAxios_tblaza.Action = 'AzaInfo/Index'
      DataAxios_tblaza.Method = 'POST'
      var formData = new FormData()
      formData.append('id', data.Id)
      DataAxios_tblaza.ArryfildValue = formData
      this.$PostFormData(DataAxios_tblaza).then((data) => {
        // console.log("***********", data);
        this.$store.state.OldDataForLog = JSON.stringify(data)
        this.$router.push({
          name: 'azainfo',
          params: { EditData: data, Status: 'Edit' },
        })
      })
    },
  },
  mounted() {
    this.GetGridColumns()
  },
}
</script>
<style scoped></style>
